import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from '../../components/static/header/header';
import Footer from '../../components/static/footer/footer';
import Spinner from '../spinner/spinner';
import "./mainLayout.scss"

const MainLayout = () => {
    document.addEventListener("contextmenu", (e) => e.preventDefault());
    return (
        <main>
            <div>
            <Header />
            <Box className="page-ht">
                <Suspense fallback={<Spinner />}>
                    <Outlet />
                </Suspense>
            </Box>
            <Footer />
            </div>
        </main>
    )
}

export default MainLayout